import unwrap from './unwrap';

export default function csvFromArrayOfArrays<T>(arrayOfArrays: T[][]): string {
  return arrayOfArrays
    .map(array => array.map(item => unwrap(item, item => '"' + String(item).replace(/"/g, `""`) + '"', '')).join(','))
    .join('\n');
}
